import { Box, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
class ByHours extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"By Hours"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Tabs
                        value={this.state.selectedTab}
                        onChange={this.handleSelectedTabChange}
                        textColor="primary"
                        indicatorColor="primary"
                        aria-label="secondary tabs example"
                        variant='fullWidth'
                    >
                        <Tab value="PERJAM" label="Per Jam" />
                        <Tab value="PER3JAM" label="Per 3 Jam" />
                        <Tab value="PERSHIFT" label="Per Shift" />
                    </Tabs>
                    <Box>
                    {
                        this.state.selectedTab === "PERJAM" && (
                            <Box>
                                {this.props.contactLeadsHourly.map(lead => {
                                    return (
                                    <Box elevation={2} sx={{mb: "5px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>{lead.label}</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"}>{lead.count} leads</Grid>
                                        </Grid>
                                        <Divider sx={{mt: "8px"}} />
                                    </Box>
                                    );
                                })}
                            </Box>
                        )
                    }
                    {
                        this.state.selectedTab === "PER3JAM" && (
                            <Box>
                                {this.props.contactLeads24Hours.map(lead => {
                                    return (
                                    <Box elevation={2} sx={{mb: "5px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>{lead.label}</strong><br />
                                                {lead.count} leads
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"}>
                                                <strong>CR : {lead.count > 0 ? (lead.countClosing/lead.count*100).toFixed(2).replace(".00", "") : 0}%</strong><br />
                                                {lead.countSalesOnline} Sales
                                            </Grid>
                                        </Grid>
                                        <Divider sx={{mt: "8px"}} />
                                    </Box>
                                    );
                                })}
                            </Box>
                        )
                    }
                    {
                        this.state.selectedTab === "PERSHIFT" && (
                            <Box>
                                {this.props.contactLeadsHourlyShift.map(lead => {
                                    return (
                                    <Box elevation={2} sx={{mb: "5px", padding: "5px"}}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={6}>
                                                <strong>{lead.label}</strong>
                                            </Grid>
                                            <Grid item xs={6} textAlign={"right"}>{lead.count} leads</Grid>
                                        </Grid>
                                        <Divider sx={{mt: "8px"}} />
                                    </Box>
                                    );
                                })}
                            </Box>
                        )
                    }
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default ByHours;